module.exports = __webpack_public_path__ + "static/img/interiorismo_comercial.dc61681.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/obras_comerciales_secciones/interiorismo_comercial.jpg
// module id = ws+Y
// module chunks = 1